import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ChooseLanguagePage } from './choose-language.page';
import { SharedModule } from '../shared-module/shared.module';
import { ChooseLanguagePageRoutingModule } from './choose-language-routing.module';

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    CommonModule,
    SharedModule,
    ChooseLanguagePageRoutingModule
  ],
  declarations: [ChooseLanguagePage]
})
export class ChooseLanguagePageModule {}
